// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarNestedItem from "../Sidebar/SidebarNestedItem.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";
import LogoSvg from "static/icons/logo.svg";

function AdminSidebarIdentity(Props) {
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  let identityId;
  if (typeof currentRoute === "number" || currentRoute.TAG !== /* Admin */7) {
    identityId = "";
  } else {
    const match = currentRoute._0;
    if (typeof match === "number" || match.TAG !== /* Identities */2) {
      identityId = "";
    } else {
      const match$1 = match._0;
      identityId = typeof match$1 === "number" ? "" : match$1._0;
    }
  }
  let tmp;
  if (typeof currentRoute === "number" || currentRoute.TAG !== /* Admin */7) {
    tmp = false;
  } else {
    const match$2 = currentRoute._0;
    if (typeof match$2 === "number" || match$2.TAG !== /* Identities */2) {
      tmp = false;
    } else {
      const match$3 = match$2._0;
      tmp = typeof match$3 === "number" || match$3._1 ? false : true;
    }
  }
  let tmp$1;
  if (typeof currentRoute === "number" || currentRoute.TAG !== /* Admin */7) {
    tmp$1 = false;
  } else {
    const match$4 = currentRoute._0;
    if (typeof match$4 === "number" || match$4.TAG !== /* Identities */2) {
      tmp$1 = false;
    } else {
      const match$5 = match$4._0;
      tmp$1 = typeof match$5 === "number" ? false : match$5._1 === 1;
    }
  }
  let tmp$2;
  if (typeof currentRoute === "number" || currentRoute.TAG !== /* Admin */7) {
    tmp$2 = false;
  } else {
    const match$6 = currentRoute._0;
    if (typeof match$6 === "number" || match$6.TAG !== /* Identities */2) {
      tmp$2 = false;
    } else {
      const match$7 = match$6._0;
      tmp$2 = typeof match$7 === "number" ? false : match$7._1 >= 2;
    }
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                  route: /* OrgChoose */0,
                                  children: JsxRuntime.jsx(LogoSvg, {
                                        alt: "logo"
                                      })
                                }),
                            className: "cursor-pointer"
                          }),
                      className: "flex justify-between px-6 pt-0 items-center"
                    }),
                JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                      route: {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* List */0
                        }
                      },
                      className: "px-6 mt-8 mb-6 flex justify-between",
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5",
                                    src: StaticAsset.src("/static/icons/back-arrow.svg")
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                    className: "ml-4 text-white",
                                    children: "Профиль"
                                  })
                            ],
                            className: "flex items-center"
                          })
                    }),
                JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
                      isActive: tmp,
                      route: {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* Item */{
                            _0: identityId,
                            _1: /* General */0
                          }
                        }
                      },
                      activeIcon: JsxRuntime.jsx("img", {
                            className: "w-5 h-5 shrink-0",
                            src: StaticAsset.src("/static/icons/profile-white-20.svg")
                          }),
                      icon: JsxRuntime.jsx("img", {
                            className: "w-5 h-5 shrink-0",
                            src: StaticAsset.src("/static/icons/profile-gray-20.svg")
                          }),
                      title: "Общая информация"
                    }),
                JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
                      isActive: tmp$1,
                      route: {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* Item */{
                            _0: identityId,
                            _1: /* Security */1
                          }
                        }
                      },
                      activeIcon: JsxRuntime.jsx("img", {
                            className: "w-5 h-5 shrink-0",
                            src: StaticAsset.src("/static/icons/lock-white-20.svg")
                          }),
                      icon: JsxRuntime.jsx("img", {
                            className: "w-5 h-5 shrink-0",
                            src: StaticAsset.src("/static/icons/lock-gray-20.svg")
                          }),
                      title: "Безопасность"
                    }),
                JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
                      isActive: tmp$2,
                      route: {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* Item */{
                            _0: identityId,
                            _1: /* API */2
                          }
                        }
                      },
                      activeIcon: JsxRuntime.jsx("img", {
                            className: "w-5 h-5 shrink-0",
                            src: StaticAsset.src("/static/icons/key-white-20.svg")
                          }),
                      icon: JsxRuntime.jsx("img", {
                            className: "w-5 h-5 shrink-0",
                            src: StaticAsset.src("/static/icons/key-gray-20.svg")
                          }),
                      title: "Ключи API"
                    })
              ],
              className: "flex flex-col bg-black py-6 relative border-r border-white/8 duration-500 transition-width ease-out w-61 overflow-y-auto"
            });
}

const make = AdminSidebarIdentity;

export {
  make ,
}
/* Buhta_cabinet__Link Not a pure module */
